import { t } from '@lingui/macro';

export const getCustomFieldLabelId = (customFieldKeyId: string): string => (
  `custom-field-key-label--${customFieldKeyId}`
);

export const getCustomFieldAccessibleName = (fieldName?: string): string => {
  const normalizedFieldName = (fieldName || '').trim();
  return normalizedFieldName || t`Custom field value`;
};
